import { useState } from 'react'

const useDAPC = () => {

    const [checkT, setCheckT] = useState({ btn1: true, btn2: true, btn3: true })

    const fCalculateLenghtT = () => {
        let aux = 0
        if (checkT.btn1) aux = aux + 1
        if (checkT.btn2) aux = aux + 1
        if (checkT.btn3) aux = aux + 1
        return aux
    }

    const fCalculateEnabledDisabledT = () => {
        let aux = []
        checkT.btn1 ? aux.push(1) : aux.push(0)
        checkT.btn2 ? aux.push(1) : aux.push(0)
        checkT.btn3 ? aux.push(1) : aux.push(0)
        return aux
    }

    // --------------------------------------------------------------
    const [checkTG, setCheckTG] = useState({ btn1: true, btn2: true, btn3: true, btn4: true, btn5: true, btn6: true, btn7: true, btn8: true, btn9: true, btn10: true })

    const fCalculateLenghtTG = () => {
        let aux = 0
        if (checkTG.btn1) aux = aux + 1
        if (checkTG.btn2) aux = aux + 1
        if (checkTG.btn3) aux = aux + 1
        if (checkTG.btn4) aux = aux + 1
        if (checkTG.btn5) aux = aux + 1
        if (checkTG.btn6) aux = aux + 1
        if (checkTG.btn7) aux = aux + 1
        if (checkTG.btn8) aux = aux + 1
        if (checkTG.btn9) aux = aux + 1
        if (checkTG.btn10) aux = aux + 1
        return aux
    }

    const fCalculateEnabledDisabledTG = () => {
        let aux = []
        checkTG.btn1 ? aux.push(1) : aux.push(0)
        checkTG.btn2 ? aux.push(1) : aux.push(0)
        checkTG.btn3 ? aux.push(1) : aux.push(0)
        checkTG.btn4 ? aux.push(1) : aux.push(0)
        checkTG.btn5 ? aux.push(1) : aux.push(0)
        checkTG.btn6 ? aux.push(1) : aux.push(0)
        checkTG.btn7 ? aux.push(1) : aux.push(0)
        checkTG.btn8 ? aux.push(1) : aux.push(0)
        checkTG.btn9 ? aux.push(1) : aux.push(0)
        checkTG.btn10 ? aux.push(1) : aux.push(0)
        return aux
    }

    // --------------------------------------------------------------

    const [checkPA, setCheckPA] = useState({ btn1: true, btn2: true, btn3: true, btn4: true, btn5: true, btn6: true, btn7: true, btn8: true, btn9: true, btn10: true, btn11: true, btn12: true, btn13: true  })

    const fCalculateLenghtPA = () => {
        let aux = 0
        if (checkPA.btn1) aux = aux + 1
        if (checkPA.btn2) aux = aux + 1
        if (checkPA.btn3) aux = aux + 1
        if (checkPA.btn4) aux = aux + 1
        if (checkPA.btn5) aux = aux + 1
        if (checkPA.btn6) aux = aux + 1
        if (checkPA.btn7) aux = aux + 1
        if (checkPA.btn8) aux = aux + 1
        if (checkPA.btn9) aux = aux + 1
        if (checkPA.btn10) aux = aux + 1
        if (checkPA.btn11) aux = aux + 1
        if (checkPA.btn12) aux = aux + 1
        if (checkPA.btn13) aux = aux + 1
        return aux
    }

    const fCalculateEnabledDisabledPA = () => {
        let aux = []
        checkPA.btn1 ? aux.push(1) : aux.push(0)
        checkPA.btn2 ? aux.push(1) : aux.push(0)
        checkPA.btn3 ? aux.push(1) : aux.push(0)
        checkPA.btn4 ? aux.push(1) : aux.push(0)
        checkPA.btn5 ? aux.push(1) : aux.push(0)
        checkPA.btn6 ? aux.push(1) : aux.push(0)
        checkPA.btn7 ? aux.push(1) : aux.push(0)
        checkPA.btn8 ? aux.push(1) : aux.push(0)
        checkPA.btn9 ? aux.push(1) : aux.push(0)
        checkPA.btn10 ? aux.push(1) : aux.push(0)
        checkPA.btn11 ? aux.push(1) : aux.push(0)
        checkPA.btn12? aux.push(1) : aux.push(0)
        checkPA.btn13 ? aux.push(1) : aux.push(0)
        return aux
    }

    return {
        checkT, fCalculateLenghtT, setCheckT, fCalculateEnabledDisabledT,
        checkTG, fCalculateLenghtTG, setCheckTG, fCalculateEnabledDisabledTG,
        checkPA, fCalculateLenghtPA, setCheckPA, fCalculateEnabledDisabledPA
    }
}

export default useDAPC